import { useMutation } from '@tanstack/react-query';

import * as service from '../services';
import { OmnichannelSavedFilters } from '../types';
import { useOmnichannelStore } from '../store/ModuloOmnichannel.store';
import { useNotification } from '../../../../../hooks';

export const useOmnichannelSaveFilters = () => {
  const { setOmnichannelState, setOmnichannelClearSavedFilters } = useOmnichannelStore();
  const { handleNotification } = useNotification();

  const saveFilters = async (data: OmnichannelSavedFilters) => {
    const resp = await service.saveOmnichannelSavedFilters(data);
    return resp;
  };

  const mutate = useMutation({
    mutationFn: saveFilters,
    onSuccess: () => {
      handleNotification('success', 'Filtro salvo com sucesso!');
      setOmnichannelClearSavedFilters();
    },
    onError: () => {
      handleNotification('error', 'Erro ao salvar filtro');
    },
  });

  const handleOmnichannelSaveFilters = () => {
    const requestBody = useOmnichannelStore.getState().omnichannelRequestBody;
    const nameSavedFilter = useOmnichannelStore.getState().nameSavedFilter;
    const bodyRequest = {
      nomeFiltroSalvo: nameSavedFilter,
      filtros: {
        ...requestBody,
      },
    };

    if (nameSavedFilter !== '') {
      mutate.mutate(bodyRequest as unknown as OmnichannelSavedFilters);
    } else {
      handleNotification('warn', 'Nome do filtro é obrigatório');
    }
  };

  const handleChangeNameSavedFilter = (name: string) => {
    setOmnichannelState('nameSavedFilter', name);
  };

  return {
    handleOmnichannelSaveFilters,
    handleChangeNameSavedFilter,
    isLoadingOmnichannelSaveFilters: mutate.isPending,
  };
};
